// บังคับให้ทุก deep-link (refresh/bookmark) เด้งกลับ / ก่อน
// เพื่อให้ bootstrap.init() ที่ index.vue ได้รัน load data ก่อนใช้งาน
// ยกเว้น path ที่อยู่ใน allowlist (login, fallback pages)

const ALLOWED_DEEP_PATHS = new Set<string>([
  '/',
  '/login',
  '/register',
  '/no-permission',
  '/account-expired',
  '/maintenance',
  '/maintainance', // typo route ที่ใช้จริงในระบบ
  '/download',
  '/sentry-test', // hidden Sentry diagnostics page (secret 10-tap on version)
]);

const ALLOWED_PREFIXES: string[] = [
  '/v2-owner-report-mobile',
];

// Public static HTML (Firebase serve ตรง — ไม่ผ่าน Nuxt):
//   /pos-ask-to-takeover.html
//   /pos-is-taken.html
//   /pos-multi-tabs-opened.html

export default defineNuxtPlugin({
  name: 'bootstrap-guard',
  enforce: 'pre',
  setup() {
    if (!import.meta.client) return;

    // Nuxt prerender + Firebase Hosting serve ที่ path มี trailing slash
    // เช่น /login/ (จากไฟล์ /login/index.html) → normalize ก่อน check allowlist
    const raw = window.location.pathname;
    const path =
      raw.length > 1 && raw.endsWith('/') ? raw.slice(0, -1) : raw;

    if (ALLOWED_DEEP_PATHS.has(path)) return;
    if (ALLOWED_PREFIXES.some((p) => path.startsWith(p))) return;

    console.log('[bootstrap-guard] redirect deep-link to /', { from: raw });
    window.location.replace('/');

    // Block plugin init so Nuxt never mounts the doomed deep-link page before
    // the browser tears the document down for the '/' reload. Without this, the
    // matched route (e.g. /v2/pos) transiently mounts — rendering the v2 shell
    // with raw i18n keys AND running its onMounted (which router.replace's to
    // /runMode) — producing the "Select Run Mode" / lock-screen flash. The
    // spa-loading-template stays up during this pending promise, so the user
    // only ever sees the branded loader until '/' loads.
    return new Promise<void>(() => {});
  },
});
